<div nz-row nzType="flex">
    <div nz-col nzSpan="5">
        <div style="font-size: 13px;" class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="19" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">

            <nz-form-item>
                <button nz-button nzType="primary" style="margin-right: 0px" (click)="fireEvent()"
                    [nzLoading]="loadprojectexcel">
                    <i nz-icon nzType="file-excel" nzTheme="outline"></i>
                </button>
            </nz-form-item>

            <nz-form-item style="margin-right:0px;">
                <button nz-button [nzType]="isFilterApplied" (click)="showFilter()">
                    <i nz-icon nzType="filter"></i></button>
            </nz-form-item>

        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter {{filterClass}}">
            <div class="filter-box">
                <form nz-form>
                    <div nz-row nzGutter="16" >
                        <div nz-col nzSpan="7">
                            <div nz-row>
                                <div nz-col nzSpan="24" >
                                    <nz-form-label nzNoColon><b style="font-size: 11px;">Date</b></nz-form-label>

                                    <nz-input-group>
                                        <div nz-row>
                                            <div nz-col nzSpan="12" class="custom-date-picker">
                                              <nz-date-picker nzSize="small" style="width: 100%;" nzFormat="dd/MM/yyyy"
                                                              name="startDate" (nzOnOpenChange)="startDateHandle($event)"
                                                              [(ngModel)]="START_DATE">
                                              </nz-date-picker>
                                            </div>
                                          
                                            <div nz-col nzSpan="12" class="custom-date-picker">
                                              <nz-date-picker nzSize="small" #endDatePicker style="width: 100%;"
                                                              nzFormat="dd/MM/yyyy" name="endDate"
                                                              [nzDisabledDate]="disabledEndDate" [(ngModel)]="END_DATE">
                                              </nz-date-picker>
                                            </div>
                                          </div>
                                          
                                    </nz-input-group>
                                </div>
                            </div>
                        </div>


                        <div nz-col nzSpan="17">
                            <nz-form-label nzNoColon><b style="font-size: 11px !important;">Users</b></nz-form-label>
                            <nz-input-group>
                                <nz-select name="Usersname" style="width: 100%;     font-size: 11px !important;" nzMode="multiple" nzMaxTagCount="5"
                                    nzShowSearch nzAllowClear [(ngModel)]="userID">
                                    <nz-option *ngFor="let user of userList" [nzValue]="user.ID"
                                        [nzLabel]="user.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>



                        <div nz-col nzSpan="24">
                            <nz-form-label nzNoColon><b style="font-size: 11px !important;">Project</b></nz-form-label>

                            <nz-input-group>
                                <nz-select nzSize="small" name="projectName" style="width: 100%;     font-size: 11px !important;" nzMode="multiple" nzMaxTagCount="5"
                                    nzShowSearch nzAllowClear [(ngModel)]="projectID">
                                    <nz-option *ngFor="let project of projectList" [nzValue]="project.ID"
                                        [nzLabel]="project.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="7">
                            <nz-form-label nzNoColon><b style="font-size: 11px !important;">Actions</b></nz-form-label><br />

                            <nz-button-group nzSize="default">
                                <button style="margin-right: 10px;font-size: 11px;" nz-button nzType="primary"
                                    (click)="getUserWiseSummary(true)" nzJustify="end">
                                    <i nz-icon nzType="filter"></i>Apply Filter
                                </button>

                                <button nz-button nzType="primary" style="font-size: 11px" (click)="clearFilter()">
                                    <i nz-icon nzType="filter"></i>Clear Filter
                                </button>
                            </nz-button-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<!-- <nz-table #nzTable class="my-scroll no-wrap1" nzBordered nzShowSizeChanger [nzFrontPagination]="false"
    [nzData]="projectData" [nzLoading]="loadingRecords" [nzScroll]="{ x: 'auto', y: '800px' }"
    style="white-space: pre-line; max-height: 500px; overflow-y: auto">
    <thead>
        <tr>
            <th nzLeft style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2" nzWidth="300px">
                <b>Employee Name</b>
            </th>
            <th nzLeft style="text-align: center; padding: 2px;  font-size: 12px;" [rowSpan]="2" nzWidth="150px">
                <b>Total Hours</b>
            </th>

            <th *ngFor="let project of projectNames" style="text-align: center ; font-size: 12px;" nzWidth="200px">
                <b>{{ project.length > 5 ? (project | slice:0:20) + '...' : project }}</b>
            </th>

        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let employee of projectData; let isLast = last">
            <td nzLeft style="text-align: left; padding: 2px;  font-size: 11px;">{{ employee.EMP_NAME }}</td>

            <td nzLeft style="text-align: center; padding: 2px; font-size: 11px;" nz-tooltip [nzTooltipTitle]="employee.TOTAL_TIME">
                {{ employee.TOTAL_TIME }}
            </td>


            <td *ngFor="let key of projectKeys" nz-tooltip [nzTooltipTitle]="employee[key]" style="text-align: center;  padding: 2px;  font-size: 11px;">
                {{ employee[key] }}
            </td>
        </tr>
    </tbody>
</nz-table> -->


<nz-table #nzTable class="my-scroll no-wrap1" nzBordered nzShowSizeChanger [nzFrontPagination]="false"
    [nzData]="projectData" [nzLoading]="loadingRecords" [nzScroll]="{ x: 'auto', y: '800px' }"
    style="white-space: pre-line; max-height: 500px; overflow-y: auto">
    <thead>
        <tr>
            <th nzLeft style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2" nzWidth="170px">
                <b>Employee Name</b>
            </th>
            <th nzLeft style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2" nzWidth="100px">
                <b>Total Hours</b>
            </th>

            <th *ngFor="let project of projectNames" style="text-align: center; font-size: 12px;" nzWidth="100px" 
            nz-tooltip [nzTooltipTitle]="project">
            <b>{{ project.length > 5 ? (project | slice:0:20) + '...' : project }}</b>
        </th>
        
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let employee of projectData; let isLast = last" [ngClass]="{'bold-row': isLast}">
            <td nzLeft style="text-align: left; padding: 2px; font-size: 11px;">{{ employee.EMP_NAME }}</td>

            <td nzLeft style="text-align: center; padding: 2px; font-size: 11px;" nz-tooltip
                [nzTooltipTitle]="employee.TOTAL_TIME">
                {{ employee.TOTAL_TIME }}
            </td>

            <td *ngFor="let key of projectKeys" nz-tooltip [nzTooltipTitle]="employee[key]"
                style="text-align: center; padding: 2px; font-size: 11px;">
                {{ employee[key] }}
            </td>
        </tr>
    </tbody>
</nz-table>

<style>
    .bold-row {
        font-weight: bold;
    }
</style>